.Testimonial {
  color: var(--brand-color-text-default);
  font-family: var(--brand-fontStack-sansSerif);
}

.Testimonial--variant-subtle,
.Testimonial--variant-default {
  position: relative;
  border-radius: var(--brand-borderRadius-xlarge);
  padding: var(--base-size-48) var(--base-size-32);
}

@media screen and (min-width: 48rem) {
  .Testimonial--variant-subtle,
  .Testimonial--variant-default {
    padding: var(--base-size-48);
  }
}

@media screen and (min-width: 63.25rem) {
  .Testimonial--variant-subtle.Testimonial--size-large,
  .Testimonial--variant-default.Testimonial--size-large {
    padding: var(--base-size-96) var(--base-size-128);
  }
}

.Testimonial--variant-subtle {
  background-color: var(--brand-color-canvas-subtle);
}

.Testimonial--variant-default {
  background-color: var(--brand-color-canvas-default);
}

.Testimonial--variant-subtle::before,
.Testimonial--variant-default::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  content: '';
  border-radius: inherit;
}

.Testimonial--variant-subtle.Testimonial--border::before {
  mask-image: var(--brand-Testimonial-borderMask-subtle);
  border: var(--brand-borderWidth-thin) solid var(--brand-color-border-default);
}

.Testimonial--variant-default.Testimonial--border::before {
  mask-image: var(--brand-Testimonial-borderMask-default);
  border: var(--brand-borderWidth-thin) solid var(--brand-color-border-default);
}

.Testimonial__quoteMark {
  --brand-Testimonial-quoteMarkColor-gradient: radial-gradient(
    circle at top left,
    var(--brand-Testimonial-quoteMarkColor-start),
    var(--brand-Testimonial-quoteMarkColor-end)
  );
  --brand-Testimonial-quoteMarkColor-background: var(
    --brand-Testimonial-quoteMarkColor-gradient,
    var(--brand-Testimonial-quoteMarkColor, currentColor)
  );
  color: var(--brand-Testimonial-quoteMarkColor-start, var(--brand-Testimonial-quoteMarkColor, currentColor));
  font-size: var(--base-size-48);
  line-height: var(--base-size-48);
  font-weight: var(--base-text-weight-extrabold);
  position: relative;
}

.Testimonial__quoteMark::before {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--brand-Testimonial-quoteMarkColor-background);
  -webkit-mask: linear-gradient(var(--brand-color-canvas-default), var(--brand-color-canvas-default)) content-box,
    linear-gradient(var(--brand-color-canvas-default), var(--brand-color-canvas-default));
  mask: linear-gradient(var(--brand-color-canvas-default), var(--brand-color-canvas-default)) content-box,
    linear-gradient(var(--brand-color-canvas-default), var(--brand-color-canvas-default));
  -webkit-mask-composite: xor;
  mask-composite: exclude;
}

.Testimonial__quoteMark--hasBackground {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: calc(var(--base-size-48) + var(--base-size-8));
  height: calc(var(--base-size-48) + var(--base-size-8));
  border-radius: var(--base-size-12);
  background-color: var(--brand-Testimonial-quoteMarkBackground, var(--base-color-scale-gray-0));
  font-size: var(--base-size-64);
  line-height: 1;
}

.Testimonial--size-large .Testimonial__quoteMark:not(.Testimonial__quoteMark--hasBackground) {
  font-size: 7.5rem; /* 120px */
  line-height: 1;
}

.Testimonial__quoteMarkGlyph {
  display: block;
}

.Testimonial-quote {
  font-family: var(--brand-fontStack-sansSerif);
  font-size: var(--brand-Testimonial-quote-fontSize-default);
  font-weight: var(--brand-Testimonial-quote-fontWeight-default);
  letter-spacing: var(--brand-Testimonial-quote-letterSpacing-default);
  line-height: 1.2; /* requires custom line-height */
  display: block;
}

.Testimonial--size-large .Testimonial-quote {
  font-size: var(--brand-Testimonial-quote-fontSize-large);
  font-weight: var(--brand-Testimonial-quote-fontWeight-large);
  letter-spacing: var(--brand-Testimonial-quote-letterSpacing-large);
}

.Testimonial-quote em,
.Testimonial-quote b {
  color: var(--brand-Testimonial-quote-color-emphasis);
  font-style: normal;
  font-weight: inherit;
}

.Testimonial__media {
  display: flex;
  gap: var(--base-size-16);
  align-items: center;
  margin-top: var(--base-size-24);
}

.Testimonial-logo-image {
  display: block;
}

.Testimonial--size-large .Testimonial__media {
  margin-top: var(--base-size-64);
}

.Testimonial-caption {
  display: flex;
  flex-direction: column;
}

.Testimonial-avatar {
  flex: none;
}

.Testimonial-from {
  font-weight: var(--base-text-weight-normal);
  text-transform: uppercase;
}

/* Expressive variant */
.Testimonial--variant-expressive {
  display: flex;
  flex-direction: column;
  gap: var(--base-size-36);
  width: 100%;
  max-width: 1176px;
  padding-inline: var(--base-size-20);
  padding-block: var(--base-size-40);
}

.Testimonial--variant-expressive .Testimonial__quoteWrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--base-size-36);
  min-width: 0;
}

.Testimonial--variant-expressive .Testimonial__media {
  flex-direction: column;
  align-items: flex-start;
  gap: var(--base-size-28);
  margin-block-start: 0;
  width: 100%;
}

.Testimonial--variant-expressive .Testimonial-avatar {
  width: var(--base-size-40);
  height: var(--base-size-40);
}

.Testimonial--variant-expressive .Testimonial-caption {
  border-block-start: var(--brand-borderWidth-thin) solid var(--brand-color-border-default);
  padding-block-start: var(--base-size-20);
  width: 100%;
  gap: var(--base-size-6);
}

@media screen and (min-width: 48rem) {
  .Testimonial--variant-expressive .Testimonial__quoteWrapper {
    gap: var(--base-size-40);
  }

  .Testimonial--variant-expressive .Testimonial__media {
    width: 356px;
  }
}

.Testimonial--variant-expressive .Testimonial-from {
  display: flex;
  align-items: center;
  gap: calc(var(--base-size-8) + var(--base-size-2));
  font-family: var(--brand-fontStack-monospace);
  font-size: var(--brand-text-size-100);
  font-weight: var(--brand-heading-weight-500);
  line-height: var(--brand-text-lineHeight-100);
  text-transform: uppercase;
  letter-spacing: 0.0107em;
}

.Testimonial--variant-expressive .Testimonial-from::before {
  content: '';
  display: inline-block;
  width: 0.5625rem;
  height: 0.875rem;
  background-color: var(--brand-color-text-emphasized);
  flex-shrink: 0;
}

.Testimonial--variant-expressive .Testimonial-position {
  font-size: var(--brand-text-size-200);
  font-weight: var(--base-text-weight-normal);
  line-height: 1.6;
  letter-spacing: 0.01em;
}

.Testimonial--variant-expressive .Testimonial__quoteMark {
  font-family: var(--brand-fontStack-monospace);
  font-weight: var(--brand-fontWeight-300);
}

.Testimonial--variant-expressive .Testimonial__quoteMarkGlyph {
  transform: translateY(var(--base-size-12));
}

.Testimonial--variant-expressive .Testimonial__quoteMark:not(.Testimonial__quoteMark--hasBackground) {
  margin-left: -0.18em;
}

.Testimonial--variant-expressive .Testimonial-quote {
  font-family: var(--brand-fontStack-monospace);
  font-size: 1.5rem;
  font-weight: 425;
  letter-spacing: -0.01em;
  line-height: var(--brand-text-lineHeight-100);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

@media screen and (min-width: 48rem) {
  .Testimonial--variant-expressive {
    max-width: 618px;
    margin-inline: auto;
    padding-inline: var(--base-size-36);
    padding-block: var(--base-size-44);
  }
  .Testimonial--variant-expressive .Testimonial-quote {
    font-size: 1.625rem;
    letter-spacing: -0.02em;
  }
}

@media screen and (min-width: 63.25rem) {
  .Testimonial--variant-expressive {
    display: grid;
    grid-template-columns: minmax(0, 744px) 312px;
    column-gap: calc(var(--base-size-96) + var(--base-size-24));
    align-items: end;
    max-width: 1176px;
    margin-inline: auto;
    padding-inline: var(--base-size-48);
    padding-block: var(--base-size-88);
  }

  .Testimonial--variant-expressive.Testimonial--hasLink {
    row-gap: var(--base-size-48);
  }

  .Testimonial--variant-expressive .Testimonial__quoteWrapper {
    grid-column: 1;
    grid-row: 1;
    gap: var(--base-size-48);
  }

  .Testimonial--variant-expressive .Testimonial__media {
    grid-column: 2;
    grid-row: 1;
    width: 312px;
    gap: var(--base-size-32);
  }

  .Testimonial--variant-expressive.Testimonial--hasLink .Testimonial__media {
    grid-row: 1 / span 2;
  }

  .Testimonial--variant-expressive .Testimonial-caption {
    padding-block-start: var(--base-size-24);
  }

  .Testimonial--variant-expressive .Testimonial-quote {
    font-size: var(--base-size-32);
  }

  .Testimonial--variant-expressive .Testimonial-link {
    grid-column: 1;
    grid-row: 2;
  }
}

@media screen and (min-width: 80rem) {
  .Testimonial--variant-expressive {
    padding-inline: 0;
  }

  .Testimonial--variant-expressive .Testimonial-avatar {
    width: var(--base-size-48);
    height: var(--base-size-48);
  }
}

.Testimonial-link {
  margin-top: var(--base-size-8);
}

.Testimonial--variant-expressive .Testimonial-link {
  align-self: flex-start;
  width: fit-content;
  margin-top: 0;
}

.Testimonial__quoteMark--default {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-default);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-default);
}

.Testimonial__quoteMark--blue {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-blue);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-blue);
}

.Testimonial__quoteMark--blue-purple {
  --brand-Testimonial-quoteMarkColor-start: var(--brand-Testimonial-quoteMarkColor-blue-purple-start);
  --brand-Testimonial-quoteMarkColor-end: var(--brand-Testimonial-quoteMarkColor-blue-purple-end);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-blue-purple);
}

.Testimonial__quoteMark--coral {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-coral);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-coral);
}

.Testimonial__quoteMark--green {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-green);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-green);
}

.Testimonial__quoteMark--green-blue {
  --brand-Testimonial-quoteMarkColor-start: var(--brand-Testimonial-quoteMarkColor-green-blue-start);
  --brand-Testimonial-quoteMarkColor-end: var(--brand-Testimonial-quoteMarkColor-green-blue-end);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-green-blue);
}

.Testimonial__quoteMark--gray {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-gray);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-gray);
}

.Testimonial__quoteMark--indigo {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-indigo);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-indigo);
}

.Testimonial__quoteMark--lemon {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-lemon);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-lemon);
}

.Testimonial__quoteMark--lime {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-lime);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-lime);
}

.Testimonial__quoteMark--orange {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-orange);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-orange);
}

.Testimonial__quoteMark--pink {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-pink);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-pink);
}

.Testimonial__quoteMark--pink-blue {
  --brand-Testimonial-quoteMarkColor-start: var(--brand-Testimonial-quoteMarkColor-pink-blue-start);
  --brand-Testimonial-quoteMarkColor-end: var(--brand-Testimonial-quoteMarkColor-pink-blue-end);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-pink-blue);
}

.Testimonial__quoteMark--purple {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-purple);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-purple);
}

.Testimonial__quoteMark--purple-red {
  --brand-Testimonial-quoteMarkColor-start: var(--brand-Testimonial-quoteMarkColor-purple-red-start);
  --brand-Testimonial-quoteMarkColor-end: var(--brand-Testimonial-quoteMarkColor-purple-red-end);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-purple-red);
}

.Testimonial__quoteMark--red {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-red);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-red);
}

.Testimonial__quoteMark--red-orange {
  --brand-Testimonial-quoteMarkColor-start: var(--brand-Testimonial-quoteMarkColor-red-orange-start);
  --brand-Testimonial-quoteMarkColor-end: var(--brand-Testimonial-quoteMarkColor-red-orange-end);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-red-orange);
}

.Testimonial__quoteMark--teal {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-teal);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-teal);
}

.Testimonial__quoteMark--yellow {
  --brand-Testimonial-quoteMarkColor: var(--brand-Testimonial-quoteMarkColor-yellow);
  --brand-Testimonial-quoteMarkBackground: var(--brand-Testimonial-quoteMarkBackground-yellow);
}
